<mat-dialog-content>
  <h1 style="padding-top: 1pt;padding-left: 1pt;text-indent: 0pt;text-align: center;">AGREEMENT TO CONDUCT BUSINESS
    ELECTRONICALLY</h1>
  <p style="padding-top: 12pt;padding-left: 6pt;text-indent: 0pt;text-align: left;">The parties to this Agreement (the
    “Parties”) are the policyholder or prospective policyholder (“Policyholder,” “You” or “Your”), GET COVERED LLC and
    QBE Insurance Corporation and its affiliated U.S insurance companies (collectively, “QBE”). QBE and GET COVERED LLC
    shall collectively be referred to herein as “Company,” “We,” “Our” or “Us.”</p>
  <p style="padding-top: 12pt;padding-left: 6pt;text-indent: 0pt;text-align: left;">You hereby agree and consent to
    enter into and sign agreements with the Company electronically, and to receive documents, notices, disclosures and
    other communications from the Company electronically, as set forth more fully herein.</p>
  <p style="padding-top: 11pt;padding-left: 6pt;text-indent: 0pt;text-align: left;">You acknowledge and agree that:</p>
  <h1 style="padding-top: 12pt;padding-left: 6pt;text-indent: 0pt;text-align: left;">Electronic Delivery of
    Communications</h1>
  <p style="padding-top: 12pt;padding-left: 6pt;text-indent: 0pt;text-align: left;">You agree to have the Company
    electronically deliver to you, documents, notices, disclosures and correspondence related to your insurance policy
    (collectively, “Communications”).</p>
  <p style="padding-left: 6pt;text-indent: 0pt;text-align: left;"> Communications include information that we are
    required to provide to you by law, or as reasonably necessary to administer your insurance policy. Such
    Communications may include, but are not limited to, your online enrollment form or application, the insurance
    policy, the policy declarations page, certificates, terms and conditions, correspondence regarding claims,
    transaction history, privacy policies, periodic billing statements, payment schedules and other correspondence
    relating to premium payments, amendments, endorsements, as well as notices and disclosures about changes in the
    terms of your insurance policy.</p>
  <h1 style="padding-top: 14pt;padding-left: 6pt;text-indent: 0pt;text-align: left;">Methods of Electronic
    Communications</h1>
  <p style="text-indent: 0pt;text-align: left;">
    <br/>
  </p>
  <p style="padding-left: 6pt;text-indent: 0pt;line-height: 108%;text-align: justify;">All Communications that we
    provide to you in electronic form will be provided by one or more of the following methods: (1) via e-mail; and /or
    (2) by access to a secure website that we will generally designate in advance for such purpose. You will need a
    username and password that You create to access this website.</p>
  <p style="padding-top: 7pt;padding-left: 6pt;text-indent: 0pt;text-align: left;">Please note that the Company may
    continue to send some Communications in paper form via US mail as required by law, or as determined by us in our
    sole discretion. Examples of such documents include policy cancellation and policy non-renewal notices.</p>
  <p style="padding-top: 12pt;padding-left: 5pt;text-indent: 0pt;text-align: justify;">You agree that all Communications
    in either electronic or paper format from the Company to you will be considered to be “in writing.” It is within
    your discretion to print or download any electronic Communications, including this Agreement for your records.</p>
  <h1 style="padding-top: 11pt;padding-left: 5pt;text-indent: 0pt;text-align: justify;">How You Can <span
    class="p">W</span>ithdraw Consent </h1>
  <p style="padding-top: 12pt;padding-left: 5pt;text-indent: 0pt;line-height: 108%;text-align: left;">This Agreement is
    voluntary. You may withdraw your consent and agreement to receive electronic Communications by contacting the
    Company at (800) 833-3448 or</p>
  <p style="padding-top: 7pt;padding-left: 5pt;text-indent: 0pt;line-height: 182%;text-align: left;">by writing to the
    Company and mailing Your withdrawal of consent to: ONE QBE WAY</p>
  <p style="padding-left: 5pt;text-indent: 0pt;line-height: 15pt;text-align: left;">SUN PRAIRIE, WI 53596</p>
  <p style="padding-top: 12pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">Any withdrawal of your consent will
    be effective only after the Company has a reasonable period of time to process your withdrawal. The withdrawal of
    your consent shall not affect the legal enforceability of Communications provided to you before the effective date
    of your cancellation. Also, the termination of your consent to conduct business electronically shall not affect the
    legal enforceability of any insurance policy.</p>
  <h1 style="padding-top: 11pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">Requesting Paper Copies of
    Electronic Communications</h1>
  <p style="padding-top: 12pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">If, after consenting to receive
    Communications electronically, you would like a paper copy of a Communication the Company previously sent, you may
    request a copy by contacting the Company as described above. Requests for paper copies must be made within a
    reasonable period of time after we first provided the electronic Communication to you. The Company will send the
    paper copy to you by U.S. mail. In order for Company to send you paper copies, we must have a current street address
    on file as Your “Home” address in your Company profile. We may charge You a reasonable service fee, of which We will
    provide You prior notice, for the delivery of paper copies of any Communication provided to You electronically
    pursuant to this authorization.</p>
  <h1 style="padding-top: 12pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">Updating Your Contact
    Information</h1>
  <h1 style="padding-top: 12pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">It is your responsibility to keep
    your primary email address up to date so that the Company can communicate with you electronically.</h1>
  <p style="padding-top: 11pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">You understand and agree that if the
    Company sends you an electronic Communication, but you do not receive it because your primary email address on file
    is incorrect, out of date, blocked by your service provider, or you are otherwise unable to receive electronic
    Communications, the Company will still be deemed to have provided the Communication to you.</p>
  <p style="padding-top: 12pt;padding-left: 6pt;text-indent: 0pt;text-align: justify;">You understand that if you use a
    spam filter that blocks or re-routes emails from senders not listed in your email address book, You must add the
    Company to Your email address book so that you will be able to receive the Communications the Company sends to
    you.</p>
  <p style="padding-top: 11pt;padding-left: 5pt;text-indent: 0pt;line-height: 108%;text-align: left;">You can update
    your primary email address at any time by calling customer service at (800) 833-3448.</p>
  <p style="padding-top: 1pt;padding-left: 6pt;text-indent: 0pt;text-align: left;">You understand that if your email
    address becomes invalid or inoperable you will not be able to transact any activity electronically with the Company
    until the Company receives a valid, working primary email address from you.</p>
  <p style="padding-top: 12pt;padding-left: 6pt;text-indent: 0pt;text-align: left;">If we are unable to consistently
    deliver email notifications to you successfully, We may unenroll you from the electronic communications program.</p>
  <h1 style="padding-top: 12pt;padding-left: 6pt;text-indent: 0pt;text-align: left;">Hardware and Software
    Requirements</h1>
  <p style="padding-top: 14pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">In order to receive electronic
    Communications, you understand that you must have a computer, tablet, smartphone or similar device that can access
    the internet as well as an email account and address (and software to access it). You further understand that you
    must have:</p>
  <p style="text-indent: 0pt;text-align: left;">
    <br/>
  </p>
  <ol id="l1">
    <li data-list-text="(a)">
      <p style="padding-left: 6pt;text-indent: 6pt;text-align: left;">A web browser that We support, such as Chrome 54
        or higher, Firefox 52 or higher, Safari 10 or higher, Microsoft Edge 14 or higher, Internet Explorer 10 or
        higher. (This is not an exclusive list -- other browsers will also work with the Company’s site);</p>
    </li>
    <li data-list-text="(b)">
      <p style="padding-left: 6pt;text-indent: 6pt;line-height: 108%;text-align: left;">Local, electronic storage
        capacity to retain Company’s Communications and/or a printer if You desire to print the Communications; and</p>
    </li>
    <li data-list-text="(c)">
      <p style="padding-left: 6pt;text-indent: 6pt;line-height: 108%;text-align: left;">Software enabling You to open
        electronic Communications and view them on your monitor.</p>
    </li>
  </ol>
  <p style="padding-top: 14pt;padding-left: 6pt;text-indent: 0pt;text-align: left;">The Company does not warrant that
    the delivery of Communications will be uninterrupted or error free. We are not liable for: any loss or damage
    arising from problems with your equipment or your telecommunications provider; your failure to meet your
    responsibilities as outlined herein; or any equipment problems or other occurrences beyond our reasonable
    control.</p>
  <p style="text-indent: 0pt;text-align: left;">
    <br/>
  </p>
  <h1 style="padding-left: 6pt;text-indent: 0pt;text-align: left;"> Law</h1>
  <p style="text-indent: 0pt;text-align: left;">
    <br/>
  </p>
  <p style="padding-left: 6pt;text-indent: 0pt;text-align: left;">You acknowledge and agree that your consent to
    transact electronic business is being provided in connection with a transaction affecting interstate commerce that
    is subject to the federal Electronic Signatures in Global and National Commerce Act, and your state&#39;s UETA
    law.</p>
  <p style="text-indent: 0pt;text-align: left;">
    <br/>
  </p>
  <h1 style="padding-left: 6pt;text-indent: 0pt;text-align: left;"> Termination / Changes to this Agreement</h1>
  <p style="padding-top: 14pt;padding-left: 6pt;text-indent: 0pt;text-align: left;">We reserve the right in our sole
    discretion to terminate or change the terms and conditions on which we provide electronic Communications. We will
    provide you with notice of any such termination or change as required by law.</p>
  <p style="text-indent: 0pt;text-align: left;">
    <br/>
  </p>
  <h1 style="padding-left: 6pt;text-indent: 0pt;text-align: left;"> Your Agreement</h1>
  <p style="padding-top: 12pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">By accepting this Agreement, you
    acknowledge and agree that you have read, understand, and agree to the terms and conditions of this Agreement.
    Further, You acknowledge and agree that you are able to view, sign and retain the Communications by using your
    device and software in</p>
  <p style="padding-top: 1pt;padding-left: 6pt;text-indent: 0pt;text-align: left;"> accordance with the technical
    requirements listed in this document, and that you have the authority to receive these Communications electronically
    on behalf of all insureds under your policy. This Agreement is effective when we electronically receive your
    acceptance.</p>
  <h1 style="padding-top: 12pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">Please print or download a copy of
    this agreement for your records.</h1>

</mat-dialog-content>

<mat-dialog-actions>
  <button mat-button
          class="mat-btn outline"
          mat-dialog-close>
    Close
  </button>
</mat-dialog-actions>
